import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function PasswordReset() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState(''); 

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/password_reset_request`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        throw new Error('Password reset request failed. Please check your email address and try again.');
      }

      const data = await response.json();
      console.log('Password reset request successful', data);

      setMessage('A password reset link has been sent to your email address. Please check your inbox.');

    } catch (error) {
      console.error('Password reset error:', error);
      setError(error.message);
    }
  };

  return (
    <div className='login-title fade-in'>
      <h1>Reset Password</h1>
      {error && <p className="reset-password-error-message">{error}</p>}
      {message && <p className="reset-password-success-message">{message}</p>}
      <form onSubmit={handleSubmit} className="user-registration-form">
        <div>
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="button-container">
          <button className="login-button" type="submit">Send Reset Link</button>
        </div>
      </form>
      <p className="registration-link">
        <Link to="/login">Back to Login</Link>
      </p>
    </div>
  );
}

export default PasswordReset;
